import client from "@/lib/api/apolloClient.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ApolloProvider} from "@apollo/client";
import {CookiesProvider} from "react-cookie";
import {IconContext} from "react-icons";
import {Outlet, ScrollRestoration} from "react-router";

export const StatusPageLayout = () => (
  <UpErrorBoundary>
    <ApolloProvider client={client}>
      <CookiesProvider>
        <IconContext.Provider value={{size: "1.25em", style: {verticalAlign: "text-top"}}}>
          <UpErrorBoundary>
            <ScrollRestoration />
            <Outlet />
          </UpErrorBoundary>
        </IconContext.Provider>
      </CookiesProvider>
    </ApolloProvider>
  </UpErrorBoundary>
);
